import axios from "axios";
import { Navigate } from "react-router-dom";

const http = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

export const interceptor = (navigate, logout) => {
  http.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        if (!error.request?.responseURL.match(/api\/(login|me)/)) {
          logout();
          return navigate("/");
        }
      }
      return Promise.reject(error);
    }
  );
};

http.defaults.withCredentials = true;
http.defaults.withXSRFToken = true;

// export const apiBaseUrl = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://booking.lib.local" : 'https://app01.lib.eduhk.hk/lbs';
export const apiBaseUrl = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://localhost" : 'https://app01.lib.eduhk.hk/lbs';

export default http;